<script lang="ts">
  // Titre de section numéroté (« 3.2 Consumo por continente ») + sous-titre + bouton
  // « copier le lien » : l'ancre est l'id de la section (lib/toc.ts).
  import { t } from '../lib/i18n.svelte';

  let { num, title, sub = '', id = '', level = 2 }: { num: string; title: string; sub?: string; id?: string; level?: 1 | 2 | 3 } = $props();
  let copied = $state(false);

  async function copy() {
    if (!id) return;
    try {
      const u = new URL(location.href); u.hash = id;
      await navigator.clipboard.writeText(u.toString());
      copied = true; setTimeout(() => (copied = false), 1600);
    } catch { /* presse-papiers indisponible : rien */ }
  }
</script>

<div class="sec-head">
  {#if level === 1}
    <h2 class="part-h"><span class="sec-n">{num}</span>{title}</h2>
  {:else if level === 3}
    <h4 class="sec-h3"><span class="sec-n">{num}</span>{title}</h4>
  {:else}
    <h3 class="sec-h"><span class="sec-n">{num}</span>{title}</h3>
  {/if}
  {#if id}
    <button class="sec-link" class:ok={copied} type="button" onclick={copy} title={t('sec.link')} aria-label={t('sec.link')}>
      <i class="ti {copied ? 'ti-check' : 'ti-link'}" aria-hidden="true"></i>
    </button>
  {/if}
</div>
{#if sub}<div class="sec-s">{sub}</div>{/if}
